import React, { useCallback } from 'react';
import { Text } from '@consta/uikit/Text';
import { Button } from '@consta/uikit/Button';
import { IconClose } from '@consta/uikit/IconClose';
import boxImport from 'src/assets/boxImport.png';

// Styles
import cn from 'classnames/bind';
import styles from './styles.styl';
import { DragNDropField } from '@consta/uikit/DragNDropField';
import { Loader } from '@consta/uikit/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { unloadExample } from 'src/redux/features/surveys/unloadExample/actions';
import { unloadExamplePendingSelector } from 'src/redux/features/surveys/unloadExample/selectors';
import { State } from 'react-beautiful-dnd';

const cx = cn.bind(styles);

export interface ImportFileModalProps {
  setModalImportCLose: (item: boolean) => void;
  loadImportSurveys: (data: any) => void;
  isImportPending: boolean;
}

export const ImportFileModal: React.FC<ImportFileModalProps> = ({
  setModalImportCLose,
  loadImportSurveys,
  isImportPending,
}) => {
  const dispatch = useDispatch();

  const handleFiles = useCallback(
    (file) => {
      const fd = new FormData();
      fd.append('file', file[0]);
      loadImportSurveys(fd);
    },
    [loadImportSurveys],
  );
  return (
    <div className={cx('ImportFileModal')}>
      <div className={cx('ImportFileModal__row')}>
        <Text size="m">{'Импорт файла'}</Text>
        <Button
          onClick={() => {
            setModalImportCLose(false);
          }}
          className={cx('ImportFileModal__button')}
          size="s"
          view="clear"
          iconRight={IconClose}
          onlyIcon
        />
      </div>
      {isImportPending ? (
        <Loader className={cx('ImportFileModal__loader')} />
      ) : (
        <DragNDropField
          accept=".xls, .xlsx, .zip"
          onDropFiles={(file) => handleFiles(file)}
        >
          {({ openFileDialog }) => (
            <div className={cx('ImportFileModal__drop')}>
              <img
                className={cx('ImportFileModal__logoDrop')}
                src={boxImport}
              />
              <div className={cx('ImportFileModal__dropRow')}>
                <Text
                  className={cx('ImportFileModal__dropText')}
                  view="secondary"
                  size="s"
                >
                  Перетащите файл или{' '}
                </Text>
                <Button
                  size="s"
                  view="clear"
                  onClick={openFileDialog}
                  label="загрузите"
                  className={cx('ImportFileModal__buttonLoad')}
                />
              </div>
              <Text
                className={cx('ImportFileModal__supported')}
                view="ghost"
                size="xs"
              >
                Поддерживаемые форматы: excel и zip
              </Text>
            </div>
          )}
        </DragNDropField>
      )}
      <Button
        size="s"
        view="clear"
        label="Скачать шаблон"
        className={cx('ImportFileModal__buttonSample')}
        loading={useSelector((state: State) =>
          unloadExamplePendingSelector(state),
        )}
        onClick={() => dispatch(unloadExample())}
      />
    </div>
  );
};
